import { Component } from '@angular/core';
import { ApiResponse } from '@hutsix/ngxh6';
import { environment } from '../../../../../../environments/environment';
import { PermitViewGrantService } from '../../../services/permit-view-grant.service';

interface PermitResult {
    /** TLC's per-type 'what happens next' line, shown on the confirmation screen. */
    submitMessage?: string | null;
    viewGrant?: string;
    viewGrantExpiresAt?: number;
    permitNumber: string;
    status: string;
    /** Shown on the confirmation so the applicant can see where it went. */
    email?: string | null;
    partySize?: number;
    token: string;
}

@Component({
    selector: 'app-apply-work',
    templateUrl: './apply-work.component.html',
    styleUrls: ['./apply-work.component.scss'],
    standalone: false,
})
export class ApplyWorkComponent {
    public result?: PermitResult | null;

    constructor(private grants: PermitViewGrantService) {}

    public get pdfUrl(): string | null {
        return this.result ? `${environment.apiUrl}/api/public/permit/${this.result.token}/pdf` : null;
    }

    public onSubmitted(res: ApiResponse<PermitResult>): void {
        // Only switch to the success panel on a real success; a validation error
        // (no status returned) must leave the form in place to show its inline errors.
        if (res?.data?.status) {
            this.result = res.data;
            // They just gave us this email on the form - don't re-ask on the next click.
            this.grants.remember(res.data);
        }
    }
}
